export const mikolajKlosowski = {
    'meta': {
        'title': 'Lekarz rezydent psychiatrii Mikołaj Kłosowski • COLLIGO',
        'description': 'Jestem lekarzem odbywającym rezydenturę w dziedzinie Psychiatrii. Ukończyłem kierunek lekarski na Collegium Medicum im. Ludwika Rydygiera w Bydgoszczy.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-klosowski/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/mikolaj-klosowski.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra w Bydgoszczy Mikołaj Kłosowski'
        }
    }
}